<div class="advanced-booking-card__wrapper">
  <div class="advanced-booking-card__main" [class.not-popup-card]="!popup">
    @if (formGroup) {
      <kt-booking-details-card
        [showFooter]="isSubmitted || isFailed"
        [showMenu]="!readOnly"
        [disableMenu]="disableMenu"
        [isActive]="isActive"
        [popup]="popup"
        [invalid]="!formGroup.valid"
        [status]="advancedBookingDetails?.shipmentStatus"
        [isCollapsed]="!showDimensions && !showBUP && !errors?.length"
        [isAllotmentModification]="isAllotmentModification"
      >
        <div class="booking-details" body [formGroup]="formGroup">
          <div class="booking-form">
            @if (
              advancedBookingDetails?.isFavorite && !isViewOnly && !hideFavorite
            ) {
              <div class="favorite-icon">
                <ng-container *ngTemplateOutlet="favoriteIcon"></ng-container>
              </div>
            }
            <div class="airline-logo">
              @if (airlineLogo) {
                <img [src]="airlineLogo" alt="" />
              }
            </div>
            <div class="airline" [class.airline-popup]="popup">
              <kt-advanced-autocomplete
                #searchField
                label="Airline"
                formControlName="airline"
                [options]="airlineOptions"
                [uppercase]="true"
                [showIcon]="true"
                [index]="index"
                [recentOptions]="recentAirlineOptions"
                [textCenter]="airlineCenterText"
                [viewOnly]="isViewOnly"
                [cardType]="cardType"
                noResultsText="Try another airline"
                (onFocus)="handleAirlineFocus()"
              >
                <div icon>
                  <svg
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.09132 14.3081L0.930077 12.4962L1.48969 11.9138L4.12531 12.517L4.33228 12.5644L4.47939 12.4113L8.29086 8.44451L8.6381 8.08311L8.19341 7.85196L0.775093 3.99575L1.66524 3.06933L11.0521 5.30392L11.2607 5.3536L11.4093 5.19894L15.2208 1.23213C15.6525 0.782845 16.3626 0.768663 16.8119 1.20036C17.2612 1.63205 17.2754 2.34219 16.8437 2.79148L13.0322 6.75829L12.8836 6.91294L12.9416 7.11944L15.5492 16.4096L14.659 17.336L10.5097 10.0776L10.261 9.64246L9.91376 10.0039L6.10229 13.9707L5.95518 14.1238L6.01078 14.3287L6.71878 16.9381L6.15916 17.5205L4.22249 14.4341L4.17266 14.3547L4.09132 14.3081Z"
                      stroke="#B6B6B6"
                      stroke-width="0.75"
                    />
                  </svg>
                </div>
              </kt-advanced-autocomplete>
            </div>
            <div
              class="origin-destination"
              [class.origin-destination-popup]="popup"
            >
              <kt-advanced-autocomplete
                label="Org"
                errorLabel="Origin"
                #searchField
                formControlName="origin"
                [options]="regionAirportsOptions"
                [excludeValues]="[formGroup.value.destination]"
                [recentOptions]="recentOriginOptions"
                [uppercase]="true"
                [textCenter]="centerText"
                [popup]="popup"
                [index]="index"
                [cardType]="cardType"
                [viewOnly]="isViewOnly"
                (onFocus)="handleOriginFocus()"
                noResultsText="Try another origin"
              ></kt-advanced-autocomplete>
              <kt-advanced-autocomplete
                label="Des"
                errorLabel="Destination"
                #searchField
                formControlName="destination"
                [recentOptions]="recentDestinationOptions"
                [options]="regionAirportsOptions"
                [excludeValues]="[formGroup.value.origin]"
                [textCenter]="centerText"
                [uppercase]="true"
                [index]="index"
                [viewOnly]="isViewOnly"
                [cardType]="cardType"
                (onFocus)="handleDestinationFocus()"
                noResultsText="Try another destination"
              ></kt-advanced-autocomplete>
            </div>
            <div class="flight-no" [class.flight-no-popup]="popup">
              <kt-advanced-autocomplete
                label="Flight no"
                errorLabel="Flight No"
                #searchField
                formControlName="flightNo"
                [options]="flightNumberOptions"
                [excludeValues]="[]"
                [uppercase]="true"
                [index]="index"
                [textCenter]="false"
                [viewOnly]="isViewOnly"
                [cardType]="cardType"
                [popup]="popup"
                noResultsText="Try another flight number"
                [allowManualInput]="true"
              ></kt-advanced-autocomplete>
            </div>
            <div class="departure">
              <kt-advanced-datepicker
                #searchField
                formControlName="departureDate"
                label="Departure"
                [viewOnly]="isViewOnly"
              ></kt-advanced-datepicker>
            </div>
            <div class="product-type">
              <cai-commodity-search
                #searchField
                label="Product Type"
                [required]="true"
                [noUpdateOnBlur]="noUpdateOnBlur"
                [(selected)]="commodityResult"
                (selectedChange)="changeProductType($event)"
                [viewOnly]="isViewOnly"
                noResultsText="Try another commodity"
              ></cai-commodity-search>
            </div>
            <div class="load-type">
              <div class="totals">
                <kt-advanced-load-type
                  #loadTypeCmp
                  [(formGroup)]="formGroup"
                  [enableUnitSwitch]="true"
                  [(loadTypeMode)]="loadTypeMode"
                  [dimensions]="dimensions"
                  [noUpdateOnBlur]="noUpdateOnBlur"
                  [disableUnitSelector]="disableUnitSelector"
                  [bups]="bups"
                  [weightUnit]="
                    this.loadTypeCmp?.loadTypeUnitState?.[loadTypeMode]
                      ?.weightUnitDetail
                  "
                  [measurementSystem]="measurementSystem"
                  (weightMeasurementSystemChanged)="
                    handleMeasurementUnitChange($event)
                  "
                  [viewOnly]="isViewOnly && !isAllotmentModification"
                ></kt-advanced-load-type>
              </div>
              @if (!isViewOnly) {
                <div class="mt-1">
                  <kt-advanced-load-type-switch
                    [(selected)]="loadTypeMode"
                    [isValidDimensions]="isValidDimensions"
                    [isValidBUPs]="isValidBUPs"
                    [(collapsed)]="collapsed"
                    (selectedChange)="changeMode($event)"
                  ></kt-advanced-load-type-switch>
                </div>
              }
            </div>
            <div class="awb" [class.popup-awb]="popup">
              <kt-advanced-awb-input
                #bookingField
                formControlName="awb"
                label="AWB"
                [viewOnly]="isViewOnly && !isAllotmentModification"
                [noUpdateOnBlur]="noUpdateOnBlur"
                [maxLength]="12"
              ></kt-advanced-awb-input>
            </div>
            <div class="allotment">
              <kt-advanced-autocomplete
                label="Allotment"
                errorLabel="Allotment"
                formControlName="allotment"
                #bookingField
                [recentOptions]="recentAllotmentOptions"
                [options]="[]"
                [excludeValues]="[]"
                [uppercase]="true"
                [textCenter]="false"
                [viewOnly]="isViewOnly"
                inputType="text"
                noResultsText="Try another allotment code"
                [allowManualInput]="true"
                (onFocus)="handleAllotmentFocus()"
              ></kt-advanced-autocomplete>
            </div>
          </div>
          @if (!isViewOnly || isAllotmentModification) {
            <div class="booking-errors">
              <kt-advanced-errors
                [formGroup]="formGroup"
                [fieldComponents]="fieldComponents"
                [errors]="errors"
              ></kt-advanced-errors>
            </div>
          }
          <div class="booking-load-type">
            <div [class.d-none]="!showDimensions">
              <div class="load-type-border"></div>
              <div class="load-type-table">
                <cai-load-type-dimension
                  #dimensionTable
                  class="dimensions-table"
                  [enableUnitSwitch]="true"
                  [mode]="loadTypeMode"
                  [minRowBeforeScroll]="3"
                  [measurementUnit]="loadTypeCmp?.measurementUnit"
                  [dimensions]="dimensions"
                  [weightUnit]="
                    this.loadTypeCmp?.loadTypeUnitState?.DIMENSIONS
                      ?.weightUnitDetail
                  "
                  [dimensionUnit]="
                    loadTypeCmp?.dimensionUnitsState?.dimensionUnitDetail
                  "
                  [measurementSystem]="
                    loadTypeCmp?.dimensionUnitsState?.measurementSystem
                  "
                  [defaultMeasurementSystem]="defaultMeasurementSystem"
                  [dimensionUnitsState]="
                    this.loadTypeCmp?.loadTypeUnitState?.[loadTypeMode]
                  "
                  (dimensionUnitsStateChange)="
                    handleDimensionUnitStateChange($event)
                  "
                  (dimensionsChange)="changeDimensions($event)"
                  (weightUnitChange)="
                    weightUnitChange(
                      $event,
                      this.loadTypeCmp.dimensionUnitsState
                    )
                  "
                  (dimensionUnitChange)="
                    dimensionUnitChange(
                      $event,
                      this.loadTypeCmp.dimensionUnitsState
                    )
                  "
                  (measurementSystemChange)="
                    measurementSystemChange(
                      $event,
                      this.loadTypeCmp.dimensionUnitsState,
                      true
                    )
                  "
                  (onUpdateTotals)="loadTypeCmp?.updateTotals()"
                ></cai-load-type-dimension>
              </div>
            </div>
            <div [class.d-none]="!showBUP">
              <div class="load-type-border"></div>
              <div class="load-type-table">
                <cai-load-type-bup
                  #bupTable
                  class="bup-table"
                  [enableUnitSwitch]="true"
                  [mode]="loadTypeMode"
                  [minRowBeforeScroll]="3"
                  [bups]="bups"
                  [origMeasurementSystem]="measurementSystem"
                  [weightUnit]="
                    this.loadTypeCmp?.loadTypeUnitState?.BUP?.weightUnitDetail
                  "
                  [defaultMeasurementSystem]="defaultMeasurementSystem"
                  (weightUnitChange)="
                    weightUnitChange($event, this.loadTypeCmp.bupUnitsState)
                  "
                  [measurementSystem]="
                    loadTypeCmp?.bupUnitsState?.measurementSystem
                  "
                  (measurementSystemChange)="
                    measurementSystemChange(
                      $event,
                      this.loadTypeCmp.bupUnitsState,
                      false
                    )
                  "
                  (bupsChange)="changeBUP($event)"
                  (onUpdateTotals)="loadTypeCmp?.updateTotals()"
                >
                </cai-load-type-bup>
              </div>
            </div>
          </div>
        </div>
        @if (isSubmitted || isFailed) {
          <div class="shipment-details" footer>
            <kt-advanced-shipment-status
              [status]="advancedBookingDetails?.shipmentStatus"
            ></kt-advanced-shipment-status>
            @if (advancedBookingDetails?.shipmentId) {
              <span class="shipment-id"
                >ID {{ advancedBookingDetails?.shipmentId }}</span
              >
            }
          </div>
        }
        <div menu>
          <kt-booking-details-menu
            [actions]="actions"
            [index]="index"
            [cardType]="advancedBookingDetails.cardType"
            (actionSelected)="selectAction($event)"
          ></kt-booking-details-menu>
        </div>
      </kt-booking-details-card>
    }
  </div>
  @if (!readOnly) {
    <div class="advanced-booking-card__action" [class.requested]="isRequested">
      @if (isSubmitted && !isLoading) {
        <div
          class="requested-buttons"
          [class.center-items-on-min]="!showCancel"
        >
          <button class="btn-shipment-details" (click)="viewShipment()">
            <svg
              width="18"
              height="18"
              viewBox="0 1 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3ZM1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9ZM9 7.5C9.41421 7.5 9.75 7.83579 9.75 8.25V12C9.75 12.4142 9.41421 12.75 9 12.75C8.58579 12.75 8.25 12.4142 8.25 12V8.25C8.25 7.83579 8.58579 7.5 9 7.5ZM9 6.75C9.41421 6.75 9.75 6.41421 9.75 6C9.75 5.58579 9.41421 5.25 9 5.25C8.58579 5.25 8.25 5.58579 8.25 6C8.25 6.41421 8.58579 6.75 9 6.75Z"
                fill="#679EC6"
              />
            </svg>
            <span i18n="@@global.shipment-details">Shipment details</span>
          </button>
          @if (
            showCancel && advancedBookingDetails.shipmentStatus !== "CANCELLED"
          ) {
            <button class="btn-cancel" (click)="cancelQuote()">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M4.66962 4.66938C4.96251 4.37648 5.43739 4.37648 5.73028 4.66938L9.99995 8.93905L14.2696 4.66938C14.5625 4.37648 15.0374 4.37648 15.3303 4.66938C15.6232 4.96227 15.6232 5.43714 15.3303 5.73004L11.0606 9.99971L15.3303 14.2694C15.6232 14.5623 15.6232 15.0371 15.3303 15.33C15.0374 15.6229 14.5625 15.6229 14.2696 15.33L9.99995 11.0604L5.73028 15.33C5.43739 15.6229 4.96251 15.6229 4.66962 15.33C4.37673 15.0371 4.37673 14.5623 4.66962 14.2694L8.93929 9.99971L4.66962 5.73004C4.37673 5.43714 4.37673 4.96227 4.66962 4.66938Z"
                  fill="white"
                />
              </svg>
              <span i18n="@@global.cancel">Cancel</span>
            </button>
          }
        </div>
      } @else {
        @if (!showSpinner || !formGroup.valid) {
          <kt-request-button
            [invalid]="isModified || isFailed"
            [isLoading]="isLoading"
            [disabled]="!formGroup.valid"
            (click)="requestBooking($event)"
          ></kt-request-button>
        }
        @if (showSpinner && formGroup.valid) {
          <div class="request-success-spinner">
            <cai-success-message
              [isShow]="showSpinner && formGroup.valid"
              [isAdvancedBookings]="true"
            ></cai-success-message>
          </div>
        }
      }
    </div>
  }
</div>

<ng-template #favoriteIcon>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.31509 0.794722C5.73936 0.550848 6.26128 0.550848 6.68555 0.794722C6.87532 0.903802 7.01906 1.07459 7.1514 1.26635C7.28295 1.45696 7.43054 1.71037 7.61261 2.02298L7.93138 2.57026C8.04819 2.77082 8.08114 2.82365 8.11867 2.86518C8.17686 2.92956 8.24783 2.98112 8.32704 3.01657C8.37813 3.03943 8.43856 3.05444 8.6654 3.10356L9.2844 3.2376C9.63797 3.31416 9.92459 3.37623 10.1465 3.44243C10.3698 3.50904 10.5766 3.59297 10.739 3.73974C11.1021 4.06788 11.2633 4.56426 11.1625 5.04312C11.1174 5.25731 10.9994 5.44679 10.8579 5.63191C10.7173 5.81591 10.5219 6.03458 10.2809 6.30433L9.85886 6.77664C9.70422 6.94972 9.66415 6.99738 9.63625 7.04591C9.593 7.12115 9.5659 7.20457 9.55666 7.29086C9.5507 7.34652 9.55511 7.40863 9.57849 7.63955L9.64229 8.2697C9.67873 8.62961 9.70828 8.92137 9.71389 9.15289C9.71954 9.38581 9.70364 9.60847 9.61423 9.80826C9.41433 10.2549 8.99209 10.5617 8.5055 10.6138C8.28787 10.6371 8.07119 10.5834 7.85141 10.5061C7.63295 10.4292 7.36459 10.3109 7.03355 10.165L6.45398 9.90963C6.24159 9.81604 6.18388 9.79266 6.1291 9.78113C6.04418 9.76325 5.95646 9.76325 5.87154 9.78113C5.81677 9.79266 5.75906 9.81604 5.54667 9.90963L4.96709 10.165C4.63605 10.3109 4.36769 10.4292 4.14923 10.5061C3.92946 10.5834 3.71278 10.6371 3.49514 10.6138C3.00855 10.5617 2.58631 10.2549 2.38642 9.80826C2.29701 9.60847 2.2811 9.38581 2.28675 9.15289C2.29237 8.92136 2.32191 8.62959 2.35836 8.26968L2.42216 7.63955C2.44554 7.40863 2.44994 7.34652 2.44398 7.29086C2.43475 7.20457 2.40764 7.12115 2.36439 7.04591C2.3365 6.99738 2.29643 6.94972 2.14178 6.77664L1.71978 6.30435C1.47874 6.03459 1.28335 5.81592 1.14272 5.63191C1.00124 5.44679 0.88323 5.25731 0.83813 5.04312C0.737298 4.56426 0.898579 4.06788 1.26162 3.73974C1.42401 3.59297 1.63085 3.50904 1.85412 3.44243C2.07605 3.37623 2.36267 3.31417 2.71623 3.23761L3.33524 3.10356C3.56208 3.05444 3.62251 3.03943 3.6736 3.01657C3.75282 2.98112 3.82378 2.92956 3.88197 2.86518C3.91951 2.82365 3.95245 2.77082 4.06927 2.57026L4.38803 2.02298C4.5701 1.71037 4.7177 1.45696 4.84925 1.26635C4.98158 1.07459 5.12533 0.903802 5.31509 0.794722ZM6.31179 1.44496C6.11894 1.3341 5.8817 1.3341 5.68885 1.44496C5.6472 1.4689 5.58084 1.5267 5.46652 1.69234C5.35331 1.85638 5.22008 2.08461 5.0282 2.41405L4.71735 2.94773C4.71189 2.95711 4.70651 2.96636 4.70119 2.97551C4.60813 3.13546 4.53498 3.26121 4.43837 3.36809C4.31035 3.50973 4.15423 3.62316 3.97996 3.70114C3.84846 3.75999 3.70625 3.79071 3.52537 3.82978C3.51503 3.83202 3.50457 3.83428 3.49397 3.83657L2.89035 3.96728C2.51774 4.04797 2.25951 4.10416 2.06852 4.16113C1.87565 4.21867 1.80018 4.26392 1.76453 4.29614C1.59951 4.4453 1.5262 4.67092 1.57204 4.88859C1.58194 4.9356 1.6164 5.01658 1.73861 5.17649C1.85964 5.33485 2.03552 5.53209 2.28954 5.81638L2.70105 6.27692C2.70828 6.28501 2.71542 6.29299 2.72247 6.30088C2.84584 6.43881 2.94283 6.54724 3.01463 6.67215C3.10977 6.83767 3.1694 7.0212 3.18972 7.21104C3.20505 7.35429 3.19033 7.49903 3.17159 7.68313C3.17052 7.69365 3.16944 7.70431 3.16834 7.7151L3.10613 8.32957C3.06772 8.70887 3.04136 8.97183 3.03653 9.17108C3.03165 9.37228 3.05137 9.45805 3.07099 9.5019C3.16186 9.70494 3.35378 9.84438 3.57496 9.86806C3.62273 9.87317 3.71039 9.86542 3.90024 9.7986C4.08825 9.73243 4.33019 9.6261 4.67906 9.47237L5.24423 9.22332C5.25416 9.21894 5.26396 9.21462 5.27364 9.21035C5.44293 9.13564 5.57603 9.07691 5.71701 9.04722C5.90384 9.00788 6.09681 9.00788 6.28364 9.04722C6.42461 9.07691 6.55771 9.13564 6.72701 9.21035C6.73669 9.21462 6.74649 9.21894 6.75641 9.22332L7.32158 9.47237C7.67046 9.6261 7.9124 9.73243 8.1004 9.7986C8.29025 9.86542 8.37791 9.87317 8.42569 9.86806C8.64686 9.84438 8.83879 9.70494 8.92965 9.5019C8.94928 9.45805 8.96899 9.37228 8.96411 9.17108C8.95928 8.97183 8.93292 8.70887 8.89452 8.32957L8.8323 7.7151C8.83121 7.70431 8.83013 7.69366 8.82905 7.68313C8.81032 7.49903 8.79559 7.35429 8.81092 7.21104C8.83124 7.0212 8.89087 6.83767 8.98602 6.67215C9.05781 6.54724 9.15481 6.43881 9.27817 6.30088C9.28523 6.29299 9.29237 6.28501 9.29959 6.27692L9.7111 5.81638C9.96512 5.53209 10.141 5.33485 10.262 5.17649C10.3842 5.01658 10.4187 4.9356 10.4286 4.88859C10.4744 4.67092 10.4011 4.4453 10.2361 4.29614C10.2005 4.26392 10.125 4.21867 9.93212 4.16113C9.74113 4.10416 9.4829 4.04797 9.11029 3.96728L8.50667 3.83657C8.49607 3.83428 8.48561 3.83202 8.47527 3.82978C8.29439 3.79071 8.15218 3.75999 8.02068 3.70114C7.84641 3.62316 7.69029 3.50973 7.56227 3.36809C7.46567 3.26121 7.39251 3.13546 7.29946 2.97551C7.29414 2.96636 7.28875 2.95711 7.28329 2.94773L6.97245 2.41405C6.78057 2.08461 6.64733 1.85638 6.53413 1.69234C6.41981 1.5267 6.35344 1.4689 6.31179 1.44496Z"
      fill="#FFC46C"
    />
    <path
      d="M5.99961 0.601074L7.77707 3.55461L11.1353 4.33238L8.87561 6.93554L9.17365 10.3698L5.99961 9.02508L2.82557 10.3698L3.12362 6.93554L0.863904 4.33238L4.22215 3.55461L5.99961 0.601074Z"
      fill="#FFC46C"
    />
  </svg>
</ng-template>
